import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import SEO from "@/components/SEO";
import Header from "@/components/Header";
import { Button } from "@/components/ui/button";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Giriş başarılı");
      navigate(u.role === "admin" ? "/adc" : u.role === "employer" ? "/isveren" : "/panel");
    } catch (e2) {
      setErr(formatApiError(e2.response?.data?.detail) || e2.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO title="Giriş Yap | isbul.org" description="isbul.org hesabınıza giriş yapın." canonical="/giris" />
      <Header />
      <div className="max-w-md mx-auto px-4 py-16">
        <div className="bg-white border border-slate-200 rounded-2xl p-8 shadow-sm">
          <h1 className="text-2xl font-bold text-[#1f222d]">Giriş Yap</h1>
          <p className="text-slate-500 text-sm mt-1">Hesabınıza erişmek için bilgilerinizi girin.</p>

          {err && <div data-testid="login-error" className="mt-4 bg-red-50 border border-red-200 text-red-600 text-sm rounded-lg px-4 py-3">{err}</div>}

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-sm font-medium text-[#1f222d]">E-posta</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full mt-1.5 border border-slate-200 rounded-xl px-4 py-3 outline-none focus:border-blue-400 text-[#1f222d]" placeholder="ornek@mail.com" />
            </div>
            <div>
              <label className="text-sm font-medium text-[#1f222d]">Şifre</label>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full mt-1.5 border border-slate-200 rounded-xl px-4 py-3 outline-none focus:border-blue-400 text-[#1f222d]" placeholder="••••••••" />
            </div>
            <Button data-testid="login-submit" disabled={busy} type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white rounded-xl py-6 text-base font-semibold">
              {busy ? "Giriş yapılıyor..." : "Giriş Yap"}
            </Button>
          </form>

          <p className="text-sm text-slate-500 text-center mt-6">
            Hesabınız yok mu? <Link to="/kayit" className="text-blue-600 font-semibold hover:underline">Kaydol</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
